var $ = global.$ = global.jQuery = global.jquery = window.$ = window.jQuery = window.jquery || require('jquery');

module.exports = $
